import { OrderingInitialState, UpdateDeliveryTypeAction } from '@reducers/ordering/types';

export const setDeliveryType = (
  state: OrderingInitialState,
  action: UpdateDeliveryTypeAction
): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    deliveryType: action.payload.deliveryType,
  },
});
